module.exports = __webpack_public_path__ + "img/letseat.a7d80dd2.png";